export const SERVER_URL = process.env.REACT_APP_AFTCR_CONTEXT_URL; // REST API 서버 Domain URL
export const IMAGE_URL = SERVER_URL + "/cmm/fms/getImage?atchFileStr=";
export const DPAUTH_URL = process.env.REACT_APP_AUTH_CONTEXT_URL; // REST API 서버 Domain URL
export const AFTCR_OS_AT = process.env.REACT_APP_AFTCR_OS_MODE; // AFTERCARE 운영모드
export const DEV_MODE_AT = SERVER_URL.includes("localhost") || SERVER_URL.includes("dev-") || SERVER_URL.includes("172.30.1");
export const DPAUTH_APIKEY = process.env.REACT_APP_DPMSG_API_KEY;

export const CMC_NU_INTFC_URL = "https://api-common.cmcnu.or.kr/was/" + process.env.REACT_APP_NU_TARGET;

export const KAKAO_REST_API_KEY = process.env.REACT_APP_KAKAO_REST_API_KEY; // 카카오 rest api 고유 키
export const KAKAO_REDIRECT_URI = process.env.REACT_APP_KAKAO_REDIRECT_URI; // 환경별 카카오 로그인 리다이렉트 uri

export const NAVER_REST_API_KEY = process.env.REACT_APP_NAVER_REST_API_KEY; // 네이버 rest api 고유 키
export const NAVER_REDIRECT_URI = process.env.REACT_APP_NAVER_REDIRECT_URI; // 환경별 네이버 로그인 리다이렉트 uri

export const GOOGLE_REST_API_KEY = process.env.REACT_APP_GOOGLE_REST_API_KEY; // 구글 rest api 고유 키
export const GOOGLE_API_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID; // 구글 클라이언트 id
export const GOOGLE_REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI; // 환경별 구글 로그인 리다이렉트 uri

export const APPLE_REDIRECT_URI = process.env.REACT_APP_APPLE_REDIRECT_URI; // 환경별 애플 로그인 리다이렉트 uri
export const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID; // 환경별 애플 로그인 리다이렉트 uri


export const DPMSG_APIKEY = process.env.REACT_APP_DPMSG_API_KEY;

export const NIPIN_AUTHKEY = "Basic " + btoa(process.env.REACT_APP_NICE_CLNT_ID+":" + process.env.REACT_APP_NICE_CLNT_SCRET);
export const NIPIN_URL = process.env.REACT_APP_NICE_IPIN_URL;

export const ERMCT_API_KEY = process.env.REACT_APP_ERMCT_API_KEY; // 약국 공공데이터 API 키

const URL = {

    // 메인
    MAIN                        : "/",    //메인페이지
    ERROR                       : "/error", // 에러페이지
    NETWORKERROR                : "/networkError", // 네트워크 에러페이지

    // SNS
    KAKAO_REDIRECT              : "/oauth/kakao/callback", // 카카오 로그인 콜백 URL
    NAVER_REDIRECT              : "/oauth/naver/callback", // 네이버 로그인 콜백 URL
    GOOGLE_REDIRECT             : "/oauth/google/callback", // 구글 로그인 콜백 URL
    APPLE_REDIRECT              : "/oauth/apple/callback", // 애플 로그인 콜백 URL

    NICE_REDIRECT              : "/nice/redirect", // 나이스 성공

    //Login
    ALLOWACCESS                 : "/AllowAccess",       // 앱 접근 권한 허용
    LANDING                       : "/Landing",             // 랜딩 페이지
    LOGINMAIN                   : "/LoginMain",           // 아이디 로그인 페이지
    IDENTITY                    : "/Identity",            // 본인 확인 방법
    MOBILEIDENTITY              : "/MobileIdentity",      // 휴대폰 본인확인
    AGREECONDITIONS             : "/AgreeConditions",     // 약관 동의
    AGREEGUARDIAN               : "/AgreeGuardian",       // 보호자 동의
    MEMBERSHIP_COMPLETE         : "/MembershipComplete",  // 가입 완료료
    HISTORY_CHECK                : "/HistoryCheck",        // 가입 이력 확인
    HOSPITAL_LINK                : "/HospitalLink",        // 병원 환자번호 연동
    HOSPITAL_LINK_COMPLETE      : "/HospitalLinkComplete",   // 병원 환자번호 연동 완료
    SIGNUP                      : "/SignUp",              // 회원 가입
    FINDID                      : "/FindId",              // 아이디 찾기
    FINDPASSWORD                : "/FindPassword",        // 비밀번호 찾기기


    //홈케어
    HOME_CARE_MAIN              : "/HomeCareMain",    //메인페이지
    HOME_TODO                   : "/homeToDo",        //홈케어 > 오늘의 할일
    CUSTOM_HEALTH               : "/HomeCareMain?tab=2",    //홈케어 > 재택치료가이드
    MEDICAL_GUIDE               : "/HomeCareMain?tab=3",    //홈케어 > 맞춤질환정보
    CALENDER                    : "/calender",        //캘린더
    PILL_ADD                    : "/PillAdd",         //복약추가
    PILL_MODIFY                 : "/PillModify",      //복약 기록수정
    PILL_DETAIL                 : "/PillDetail",      //복약 기록 상세
    PILL_DETAIL_USER            : "/PillDetailUser",      //복약 기록 상세 (사용자 지정 복약)
    PILL_ALARM                  : "/PillAlarm",       //복약 기록 상세세
    HEALTH_ADD                  : "/HealthAdd",       //건강기록 추가
    HEALTH_WRITE                : "/HealthWrite", //건강 일지 수정
    HEALTH_WRITE_LIST           : "/HealthWriteList", //건강 일지 수정 리스트
    HEALTH_DETAIL               : "/HealthDetail",    //건강 기록 상세
    HEALTH_ALARM                : "/HealthAlarm",     //건강 기록 알림
    EMOTION_ADD                 : "/EmotionAdd",      //감정 일지 추가
    EMOTION_WRITE_LIST          : "/EmotionWriteList",      //감정 일지 수정 리스트
    EMOTION_WRITE               : "/EmotionWrite",      //감정 일지 수정
    BLOOD_PRESSURE_RECORD       : "/BloodPressureRecord",    //혈압기록
    BLOOD_PRESSURE_WRITE        : "/BloodPressureWrite",    //혈압기록하기
    BLOOD_SUGAR_RECORD          : "/BloodSugarRecord",    //혈당기록
    BLOOD_SUGAR_WRITE           : "/BloodSugarWrite",    //혈당기록하기
    BODY_MASS_RECORD            : "/BodyMassRecord",    //체질량 기록
    BODY_MASS_WRITE             : "/BodyMassWrite",    //체질량 기록하기
    STEPS_MAIN                  : "/StepsMain",         //걸음수 메인
    STEPS_DASHBOARD             : "/StepsDashboard",    //걸음수 기록 대시보드
    STEPS_RECORD_LIST           : "/StepsRecordList",    //걸음수 기록 리스트
    DISEASE_SETTING             : "/DiseaseSetting",    //질환 설정
    NOTICE_BOARD_MOVIE_DETAIL    : "/NoticeBoradMovieDetail",    //동영상 게시판 상세보기 // 01
    NOTICE_BOARD_CARD_DETAIL    : "/NoticeBoradCardDetail",     //카드 게시판 상세보기 // 04
    NOTICE_BOARD_SLIDE_DETAIL    : "/NoticeBoradSlideDetail",    //슬라이드드 게시판 상세보기 // 03
    NOTICE_BOARD_PDF_DETAIL    : "/NoticeBoradPdfDetail",    //PDF 게시판 상세보기 // 02

    CUSTOM_HEALTH_CARD_DETAIL    : "/CustomHealthCardDetail",     //맞춤질환 카드 게시판 상세보기 //
    CUSTOM_HEALTH_SLIDE_DETAIL    : "/CustomHealthSlideDetail",     //맞춤질환 슬라이드 게시판 상세보기 //
    CUSTOM_HEALTH_MOVIE_DETAIL    : "/CustomHealthMovieDetail",     //맞춤질환 비디오 게시판 상세보기 //


    PRE_QUESTION_MAIN           : "/PreQuestionMain",   // 사전 설문지 메인
    PRE_QUESTION                : "/PreQuestion",   // 사전 설문지

    //설문지
    SURVEY_01                : "/Survey_01",   // 설문지01 - 전반적인 활동 상태 설문지
    SURVEY_02                : "/Survey_02",   // 설문지02 - 동반 질환 확인 설문
    SURVEY_03                : "/Survey_03",   // 설문지03 - 일상생활 동작 수행 능력 평가
    SURVEY_04                : "/Survey_04",   // 설문지04 - 집안일 및 외부 활동 수행 능력 설문지
    SURVEY_05                : "/Survey_05",   // 설문지05 - 기억력 및 인지기능 자가진단 설문
    SURVEY_06                : "/Survey_06",   // 설문지06 - 기분 상태 및 스트레스 자가진단 설문 -
    SURVEY_07                : "/Survey_07",   // 설문지07 - 최근 삶의 질 평가 설문
    SURVEY_08                : "/Survey_08",   // 설문지08 - 숙주반응 자가 평가
    SURVEY_09                : "/Survey_09",   // 설문지09 - 최근 삶의의 질 평가 설문 (신체적, 정서적 상태 및 증상 경험 등을 종합적으로 파악하여 환자 중심의 치료와 지지적 간호에 반영하기 위한 설문입니다.)
    SURVEY_10                : "/Survey_10",   // 설문지10 - 손발 저림, 감각이상 증상 체크 설문지
    SURVEY_11                : "/Survey_11",   // 설문지11 - FACT_BMT (조혈모세포이식 환자 삶의 질 평가)
    SURVEY_15                : "/Survey_15",   // 설문지15 - 만성 이식합병증 증상 평가 설문
    SURVEY_16                : "/Survey_16",   // 설문지16 - 당뇨병성 신경병증 관련 설문 (은평 성모/내분비내과)
    SURVEY_17                : "/Survey_17",   // 설문지17 - 당뇨병 위험도 점검 (은평 성모/내분비내과)
    SURVEY_18                : "/Survey_18",   // 설문지18 - 당뇨병성 신경병증 관련 설문 (은평 성모/신장내과)
    SURVEY_19                : "/Survey_19",   // 설문지19 - 당뇨병 위험도 점검 (은평 성모/신장내과)
    SURVEY_20                : "/Survey_20",   // 설문지20 - 당뇨병성 신경병증 관련 설문 (은평 성모/순환기내과)
    SURVEY_21                : "/Survey_21",   // 설문지21 - 당뇨병 위험도 점검 (은평 성모/순환기내과)
    SURVEY_22                : "/Survey_22",   // 설문지22 - 당뇨병성 신경병증 관련 설문 (은평 성모/이비인후과)
    SURVEY_23                : "/Survey_23",   // 설문지23 - 당뇨병 위험도 점검 (은평 성모/이비인후과)

    SURVEY_24                : "/Survey_24",   // 설문지24 - 단백질식단 섭취 설문 (은평 성모/신장내과)
    SURVEY_25                : "/Survey_25",   // 설문지25 - 이명 설문 (은평 성모/이비인후과)
    SURVEY_26                : "/Survey_26",   // 설문지26 - 이명 장애 척도 설문 (은평 성모/이비인후과)
    SURVEY_27                : "/Survey_27",   // 설문지27 - 어지럼증 설문 (은평 성모/이비인후과)
    SURVEY_28                : "/Survey_28",   // 설문지28 - 어지럼증 설문 (은평 성모/이비인후과)

    SURVEY_CUSTOM            : "/SurveyCustom",   // 맞춤 설문지



    //병원케어
    HOSPITAL_HOME                          : "/hospitalCare", //병원케어 홈

    HOSPITAL_MEDICALHISTORY                 : "/hospitalCare/MedicalHistory", //병원케어 > 진료내역
    HOSPITAL_MEDICALRESERVATIONHISTORY      : "/hospitalCare/MedicalReservationHistory", //병원케어 > 진료예약내역
    HOSPITAL_PRESCRIPTIONHISTORY            : "/hospitalCare/PrescriptionHistory", //병원케어 > 처방내역
    HOSPITAL_INSPECTIONHISTORY              : "/hospitalCare/InspectionHistory", //병원케어 > 검사내역

    HOSPITAL_MEDICALDETAILS                 : "/hospitalCare/MedicalDetails", //병원케어 > 진료내역 상세
    HOSPITAL_MEDICALOUTDETAILS              : "/hospitalCare/MedicalOutDetails", //병원케어 > 진료내역 상세 (비대면)
    PAY_MEDICAL_EXPENSES                    : "/hospitalCare/MedicalOutDetails/PayMedicalExpenses", //병원케어 > 진료내역 상세 > 진료비 수납하기
    HOSPITAL_MEDICALRESERVATIONDETAILSIN    : "/hospitalCare/MedicalReservationDetailsIn", //병원케어 > 진료예약 상세 (외래)
    HOSPITAL_MEDICALRESERVATIONDETAILSOUT   : "/hospitalCare/MedicalReservationDetailsOut", //병원케어 > 진료예약 상세 (비대면)
    NONCONTACT_MEDICAL_COVER                : "/hospitalCare/MedicalReservationDetailsOut/coverPage", //병원케어 > 진료예약 상세 > 커버 화면
    HOSPITAL_PRESCRIPTIONDETAIL             : "/hospitalCare/PrescriptionDetail", //병원케어 > 처방내역 상세
    HOSPITAL_INSPECTIONDETAIL               : "/hospitalCare/InspectionDetail", //병원케어 > 검사내역 상세
    HOSPITAL_PRESCRIPTIONCHECK              : "/hospitalCare/PrescriptionCheck", //병원케어 > 처방전 확인하기
    HOSPITAL_PHARMACYFIND                   : "/hospitalCare/PharmacyFind", //병원케어 > 처방전 확인하기 > 근처 약국 찾기


    HOSPITAL_HOSPITALINFORMATION            : "/hospitalCare/HospitalInformation", //병원케어 > 병원정보
    HOSPITAL_DEPARTMENTINFORM               : "/hospitalCare/DepartmentInform", //병원케어 > 병원정보 > 진료과/의료진 안내
    HOSPITAL_DEPARTMENTDETAIL               : "/hospitalCare/DepartmentDetail", //병원케어 > 병원정보 > 진료과/의료진 안내 > 상세
    HOSPITAL_DOCTORDETAIL                   : "/hospitalCare/DoctorDetail", //병원케어 > 병원정보 > 진료과/의료진 안내 > 의료진 상세
    HOSPITAL_LOCATIONINFO                   : "/hospitalCare/LocationInfo", //병원케어 > 병원정보 > 진료실/검사실 위치 안내
    //HOSPITAL_LOCATIONIMAGEVIEW              : "/hospitalCare/LocationImageView", //병원케어 > 병원정보 > 진료실/검사실 위치 이미지 뷰
    HOSPITAL_PHONENUMINFO                   : "/hospitalCare/PhoneNumInfo", //병원케어 > 병원정보 > 주요 전화번호 안내
    HOSPITAL_AMENITY                        : "/hospitalCare/Amenity", //병원케어 > 편의시설
    HOSPITAL_DIRECTIONS                     : "/hospitalCare/Directions", //병원케어 > 오시는 길
    HOSPITAL_PARKING                        : "/hospitalCare/Parking", //병원케어 > 주차안내
    HOSPITAL_PARENTALSETTINGS               : "/hospitalCare/ParentalSettings", //병원케어 > 가족/보호자 설정
    HOSPITAL_PARENTALREGISTER               : "/hospitalCare/ParentalRegister", //병원케어 > 가족/보호자 등록록

    HOSPITAL_NOTICELISTS                    : "/hospitalCare/NoticeLists", //병원케어 > 공지사항 리스트
    HOSPITAL_NOTICEDETAIL                   : "/hospitalCare/NoticeDetail", //병원케어 > 공지사항 상세
    HOSPITAL_FAQLISTS                       : "/hospitalCare/FAQLists", //병원케어 > 자주찾는 질문

    // HOSPITAL_USERHISTORY                    : "/hospitalCare/MedicHistory", //병원케어 > 진료검사 내역
    // HOSPITAL_RESERVATIONIN                  : "/hospitalCare/ReservationIn", //병원케어 > 내원예약
    // HOSPITAL_RESERVATIONOUT                 : "/hospitalCare/ReservationOut", //병원케어 > 비대면 예약

    //알림
    ALARM                       : "/Alarm", //알림 홈

    //내정보
    MY_PAGE_MAIN                   : "/MyPageMain/*", //내정보
    MY_PAGE_SUMMARY                : "/MyPageMain/summary", //내정보요약정보
    MY_PAGE_DETAIL                 : "/MyPageMain/detail", //내정보상세정보

    MY_DATA_COLLECT                : "/MyPage/MyDataCollect", //내 의료 정보 모으기

    DIAGNOSIS_MORE                 : "/MyPage/DiagnosisMore", //주요 진단 더보기
    SURGERY_MORE                   : "/MyPage/SurgeryMore", // 주요 수술/처치력 더보기
    MEDICATION_MORE                : "/MyPage/MedicationMore", //주요 약물 더보기
    INSPECTION_MORE                : "/MyPage/InspectionMore", //주요 검사결과 더보기
    DOCTOR_MORE                    : "/MyPage/DoctorMore", //주치의 더보기

    MY_DATA_VIEW_SETTING           : "/MyPage/MyDataViewSetting",  // 화면 설정

    BASIC_INFO_WRITE               : "/MyPage/BasicInfoWrite",  // 기본정보 수정
    ALLERGY_LIST_WRITE             : "/MyPage/AllergyListWrite",  //  알레르기 수정
    PAST_HISTORY_WRITE             : "/MyPage/PastHistoryWrite",  // 과거력 수정
    FAMILY_HISTORY_WRITE           : "/MyPage/FamilyHistoryWrite",  // 가족력 수정
    DRUGS_LIST_WRITE               : "/MyPage/DrugsListWrite",  // 현재 복용중인 약물 수정

    INSPECTION_TOTAL_DETAIL         : "/MyPage/InspectionTotalDetail", //내정보-상세정보-전체-검사상세 페이지 공통 사용불가로 페이지 생성

    //전체 메뉴
    TOTAL_MENU                      : "/TotalMenu", // 전체 메뉴
    APP_SETTINGS                    : "/AppSettings", // 앱 설정
    MYINFO_WRITE                    : "/MyInfoWrite", // 앱 설정 > 내 정보 수정
    CHANGE_PASSWORD                 : "/ChangePassword", // 앱 설정 > 내 정보 수정 > 비밀번호 변경
    MY_INFO_WITHDRAW                : "/MyInfoWithdraw", // 앱 설정 > 내 정보 수정 > 탈퇴하기
    APP_ALARM_SETTING                :"/AppAlarmSetting", // 앱 설정 > 앱 알림 설정
    CUSTOM_DISEASE_SETTING            :"/CustomDiseaseSetting", // 앱 설정 > 맞춤 질환 정보 설정
    MY_HOSPITAL_SETTING               :"/MyHospitalSetting", // 앱 설정 > 내 병원 설정
    MY_HOSPITAL_DISCONNECT            :"/MyHospitalDisconnect", // 앱 설정 > 내 병원 설정 > 병원 연결 해제
    MY_HOSPITAL_CONNECTION            :"/MyHospitalConnection", // 앱 설정 > 내 병원 설정 > 병원 연결
    MY_HOSPITAL_LINK                  :"/MyHospitalLink",  // 앱 설정 > 내 병원 설정 > 병원 연결 > 병원 환자번호 연동
    MAIN_HOSPITAL_SETTING             :"/MainHospitalSetting", // 앱 설정 > 내 병원 설정 > 대표 병원 설정
    HOSPITAL_ORDER_SETTING            :"/HospitalOrderSetting", // 앱 설정 > 내 병원 설정 > 병원 순서 변경
    RECORD_SETTING                    :"/RecordSetting", // 앱 설정 > 기록설정
    RECORD_SETTING_DETAIL             :"/RecordSettingDetail", // 앱 설정 > 기록설정 > 기록 설정 세부
    SERVICE_NOTICE                    :"/ServiceNotice", // 앱 설정 > 서비스 공지사항
    SERVICE_NOTICE_DETAIL             :"/ServiceNoticeDetail", // 앱 설정 > 서비스 공지사항 > 상세보기
    SERVICE_USE_GUIDE                 :"/ServiceUseGuide", // 앱 설정 > 서비스 이용 가이드
    SERVICE_USE_GUIDE_DETAIL          :"/ServiceUseGuideDetail", // 앱 설정 > 서비스 이용 가이드 > 상세보기
    SERVICE_FAQ_LISTS                 :"/ServiceFaqLists", // 앱 설정 > 자주하는 질문
    SERVICE_POLICY                    :"/ServicePolicy", // 앱 설정 > 서비스 약관 및 정책
    SERVICE_POLICY_DETAIL             :"/ServicePolicyDetail", // 앱 설정 > 서비스 약관 및 정책 > 상세보기
    APP_VERSION                       :"/AppVersion", // 앱 설정 > 앱 버전 정보
    ERROR_REPORT                      :"/ErrorReport", // 앱 설정 > 오류 제보
    ACCESSIBILITY_SETTING             :"/Accessibility", // 앱 설정 > 고대비 설정
    TTS_SETTING                       :"/AppSettings/tts",
    BUSINESS_INFORM                   :"/BusinessInform", // 앱 설정 > 사업자 정보



    //채팅
    SERVICE_CHAT                      : "/ServiceChat",       // 서비스 이용 안내
    NUTRITION_CHAT                    : "/NutritionChat", // 영양 상담



    //비대면
    NONFACE_LOGIN_MAIN                : "/NonFaceLoginMain",       // 비대면 로그인
    NONFACE_SIGNUP                    : "/NonFaceSignUp",       // 비대면 회원가입
    NONFACE_AGREE_CONDITIONS          : "/NonFaceAgreeConditions",       // 비대면 회원가입 약관
    NONFACE_FINDID                    : "/NonFaceFindId",       // 비대면 아이디 찾기
    NONFACE_FINDPASSWORD              : "/NonFaceFindPassword",       // 비대면 비밀번호 찾기
    NONFACE_CHANGEPASSWORD            : "/NonFaceChangePassword",       // 비대면 비밀번호 변경
    NONFACE_COMPLETE                  : "/NonFaceComplete",       // 비대면 완료
    NONFACE_WITHDRAW                  : "/NonFaceWithdraw",       // 비대면 탈퇴

    CONTACTLESS_MAIN                  : "/ContactlessMain",       // 비대면 상담 메인
    CONTACTLESS_DETAIL                : "/ContactlessDetail",       // 비대면 상담 상세
    CONTACTLESS_SETTING               : "/ContactlessSetting",       // 비대면 setting 화면
    CONTACTLESS_EDIT                  : "/ContactlessEdit",       // 비대면 edit 화면
    CONTACTLESS_NOTI                  : "/ContactlessNotice",       // 비대면 알림게시판 화면
    HOSPITAL_LINKAGE                  : "/HospitalLinkage",       // 비대면 병원연동 화면
    FILE_UPLOAD                       : "/FileUpload",       // 비대면 파일 업로드


    PAYMENT_REGISTER                  : "/pay/register", //결제등록
    PAYMENT_RESULT                    : "/pay/result", //결제리턴


    //환자앱 apk 다운전용
    APK_DOWNLOAD                      : "/ApkDownload", // APK 다운로드 페이지
}

export default URL;
